import { createFileRoute } from "@tanstack/react-router";
import BlogPost from "@/pages/BlogPost";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/blog/$slug/")({
  loader: async ({ params }) => {
    const { getBlogPostBySlug } = await import("@/data/blogPosts");
    const post = getBlogPostBySlug(params.slug);
    if (!post) return { post: null };
    return {
      post: {
        slug: post.slug,
        title: post.title,
        excerpt: post.excerpt,
        date: post.date,
        dateModified: post.dateModified ?? null,
        author: post.author,
        category: post.category,
        image: post.image ?? null,
      },
    };
  },
  head: ({ params, loaderData }) => {
    const base = routeHead("/uk/blog/$slug/", params as Record<string, string>);
    const post = loaderData?.post;
    if (!post) return base;

    const url = `https://roautomarket.ro/uk/blog/${post.slug}`;
    const image = post.image
      ? post.image.startsWith("http")
        ? post.image
        : `https://roautomarket.ro${post.image}`
      : "https://roautomarket.ro/hero-roautomarket.jpg";

    return {
      ...base,
      meta: [
        ...base.meta,
        { property: "og:type", content: "article" },
        { property: "article:published_time", content: post.date },
        { property: "article:author", content: post.author },
        { property: "og:image", content: image },
        { name: "twitter:image", content: image },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: post.title,
            description: post.excerpt,
            image,
            datePublished: post.date,
            dateModified: post.dateModified || post.date,
            articleSection: post.category,
            author: {
              "@type": "Person",
              name: post.author,
              url: "https://roautomarket.ro/despre-noi",
            },
            publisher: {
              "@type": "Organization",
              name: "RO Auto Market",
              logo: {
                "@type": "ImageObject",
                url: "https://roautomarket.ro/og-roautomarket.png",
              },
            },
            mainEntityOfPage: { "@type": "WebPage", "@id": url },
          }),
        },
      ],
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <BlogPost />
  );
}
